import { render, staticRenderFns } from "./ModalUserToken.vue?vue&type=template&id=47da86e9"
import script from "./ModalUserToken.vue?vue&type=script&lang=js"
export * from "./ModalUserToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports